<div class="label-wrapper">
  <span class="label-text">{{ label }}</span>

  @if (required) {
    <span class="required-star">*</span>
  }

  @if (tooltip) {
    <div class="tooltip-wrapper" [attr.data-tooltip]="tooltip">
      <svg
        class="info-icon"
        [attr.width]="size"
        [attr.height]="size"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="12" x2="12" y2="16"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      </svg>
    </div>
  }
</div>
